// extracted by mini-css-extract-plugin
export default {"spinnerContainerClassName":"FullscreenSpinner_spinnerContainerClassName__phCpM","fadeIn":"FullscreenSpinner_fadeIn__8A-G9","fadeOut":"FullscreenSpinner_fadeOut__s34I8"};